import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "viewBox", "aria-labelledby"]


export default /*#__PURE__*/_defineComponent({
  __name: 'VIconBase',
  props: {
  name: {
    type: String,
    default: 'box'
  },
  viewBox: {
    type: String,
    default: '0 0 24 24'
  },
  size: {
    type: [Number, String],
    default: 24
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: __props.size,
    height: __props.size,
    viewBox: __props.viewBox,
    "aria-labelledby": __props.name,
    role: "presentation",
    fill: "none"
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 8, _hoisted_1))
}
}

})